import React from "react";
import PropTypes from "prop-types";

const TableHeadCell = ({ children, colspan, scope, className, label }) => {
  return (
    <th className={className} colSpan={colspan} scope={scope} data-label={label}>
      {children}
    </th>
  );
};

TableHeadCell.propTypes = {
  label: PropTypes.string,
  scope: PropTypes.oneOf(["row", "col"]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  colspan: PropTypes.string,
  className: PropTypes.string,
};

TableHeadCell.defaultProps = {
  className: "",
  label: "",
};

export default TableHeadCell;
